import { render, staticRenderFns } from "./KeyValueDataView.vue?vue&type=template&id=22ab8bf2"
import script from "./KeyValueDataView.vue?vue&type=script&lang=js"
export * from "./KeyValueDataView.vue?vue&type=script&lang=js"
import style0 from "./KeyValueDataView.vue?vue&type=style&index=0&id=22ab8bf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports